(() => {
  if (customElements.get('product-message')) return;

  class ProductMessage extends HTMLElement {
    connectedCallback() {
      if (this.dataset.productMessageReady === 'true') return;
      this.dataset.productMessageReady = 'true';

      const blockId = this.dataset.blockId || this.id || 'default';
      this.storageKey = `product-message-closed-${blockId}`;
      this.closeButton = this.querySelector('.js-close-message');

      if (!this.shouldDisplay()) return;

      this.showMessage();

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeMessage());
      }

      if (this.dataset.showOverMedia === 'true') {
        const seconds = parseInt(this.dataset.visibilityDuration || '7', 10);
        if (seconds > 0) {
          window.setTimeout(() => this.closeMessage(false), seconds * 1000);
        }
      }
    }

    shouldDisplay() {
      const designMode = window.Shopify && window.Shopify.designMode;

      if (!designMode && this.dataset.persistentClose === 'true') {
        try {
          if (window.localStorage.getItem(this.storageKey) === 'true') return false;
        } catch (error) {
          // localStorage may be unavailable in private browsing; continue gracefully.
        }
      }

      const startsAt = this.parseDate(this.dataset.triggerActivate);
      const endsAt = this.parseDate(this.dataset.triggerDeactivate);
      const now = new Date();

      if (startsAt && now < startsAt) return false;
      if (endsAt && now > endsAt) return false;

      return this.discountCodeMatches();
    }

    parseDate(value) {
      if (!value) return null;

      const normalized = String(value).trim().replace(' ', 'T');
      const parsed = new Date(normalized);

      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    discountCodeMatches() {
      const requiredCode = (this.dataset.triggerDiscountCode || '').trim().toLowerCase();
      if (!requiredCode) return true;

      const valuesToSearch = [
        document.cookie || '',
        window.location.search || ''
      ];

      try {
        valuesToSearch.push(window.localStorage.getItem('discount_code') || '');
        valuesToSearch.push(window.localStorage.getItem('discountCode') || '');
        valuesToSearch.push(window.sessionStorage.getItem('discount_code') || '');
        valuesToSearch.push(window.sessionStorage.getItem('discountCode') || '');
      } catch (error) {
        // Storage can be blocked; cookie and URL checks still cover most cases.
      }

      return valuesToSearch.some((value) =>
        decodeURIComponent(value).toLowerCase().includes(requiredCode)
      );
    }

    showMessage() {
      this.hidden = false;

      window.requestAnimationFrame(() => {
        this.classList.remove('product-message--out');
        this.classList.add('product-message--in');
      });
    }

    closeMessage(saveClose = true) {
      if (saveClose && this.dataset.persistentClose === 'true') {
        try {
          window.localStorage.setItem(this.storageKey, 'true');
        } catch (error) {
          // Ignore storage failures; the message can still close for this view.
        }
      }

      this.classList.add('product-message--closing');

      window.setTimeout(() => {
        this.hidden = true;
      }, 180);
    }
  }

  customElements.define('product-message', ProductMessage);
})();